// Ported from dev-scrips-pm-react src/billing/lib/reason-select.ts (PROD-3312 appointment Billing tab).
/**
 * Width class for a reason-picker dropdown (cancel invoice / void payment).
 *
 * The cancellation / void reason value-sets have long labels (e.g. "Patient
 * requested cancellation / no longer proceeding with treatment"). shadcn's
 * SelectContent defaults to `w-(--anchor-width)` — locked to the trigger width —
 * so inside the narrow cancel/void dialogs (`sm:max-w-md`) the options were
 * horizontally CLIPPED (verified via Playwright: the longest item measured
 * scrollWidth 403 > clientWidth 352). Widening the trigger with `w-full` does
 * not help: the popup still matches the trigger, which is bounded by the dialog.
 *
 * This lets the popup grow to its content — at least the trigger width, at most
 * the viewport — so the full reason text shows on one line. Re-measured after
 * the fix: popup 352 → 435px, 0 clipped items.
 *
 * Apply to the reason `<SelectContent>` in every cancel/void reason dropdown so
 * they stay consistent (PROD-1798 follow-up).
 */
// PA (PROD-3312): pm-react's value is 'w-[max-content] min-w-(--anchor-width) max-w-[calc(100vw-2rem)]'. The PA bans
// arbitrary classes (scripts/check-no-arbitrary-classes.mjs), so this is the named-class equivalent: grow to content,
// capped at the viewport. The trigger-width floor and the 2rem gutter have no named class; re-check when the reason
// pickers land (PROD-3312).
export const REASON_SELECT_CONTENT_CLASS =
  'w-max max-w-screen';
